import { useQuery } from "@tanstack/react-query";
import { getUsersByCompany } from '../axiosNetworkRequest/people';

const FIVE_MINUTES = 5 * 60 * 1000;

export const useGetUsersByCompany = (company_id: number) => {
  return useQuery({
    queryKey: ['users-by-company', company_id],
    queryFn: () => getUsersByCompany(`user/get-users-by-company?mh_primary_company_id=${company_id}`),
    staleTime: FIVE_MINUTES,
    enabled: company_id > 0,
  });
};
